"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateEventData = exports.generateEventContent = exports.formatCalendarDateTime = exports.formatCalendarDate = void 0;
var date_fns_1 = require("date-fns");
var formatCalendarDate = function (date) { return (0, date_fns_1.format)(date, 'yyyyMMdd'); };
exports.formatCalendarDate = formatCalendarDate;
var formatCalendarDateTime = function (date) {
    // strip Z otherwise format alters time to local timezone
    return (0, date_fns_1.format)(date.toISOString().replace('Z', ''), "yyyyMMdd'T'hhmmss");
};
exports.formatCalendarDateTime = formatCalendarDateTime;
// Generate the contents of an iCalendar file. See https://icalendar.org/.
var generateEventContent = function (_a) {
    var date = _a.date, title = _a.title, description = _a.description, uid = _a.uid;
    return [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:OEPUI',
        'BEGIN:VEVENT',
        'UID:' + uid,
        'DTSTAMP:' + (0, exports.formatCalendarDateTime)(new Date()),
        'DTSTART;VALUE=DATE:' + (0, exports.formatCalendarDate)(date),
        'SUMMARY:' + title,
        'DESCRIPTION:' + description,
    ].join('\n');
};
exports.generateEventContent = generateEventContent;
// URI encoded iCalendar file to be used as an href.
var generateEventData = function (props) {
    var content = (0, exports.generateEventContent)(props);
    return encodeURI('data:text/calendar;charset=utf8,' + content);
};
exports.generateEventData = generateEventData;
